import { cn } from '@exam-room/utils';

import { Form } from '../../../../../components';

interface RadioButtonProps {
  id: string;
  name: string;
  value: string;
  label?: JSX.Element;
  endAdornment?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

function RadioButton(props: Readonly<RadioButtonProps>) {
  const { id, name, value, className, label, endAdornment, disabled = false } = props;

  return (
    <div className='flex items-start gap-4'>
      <Form.Radio
        id={id}
        name={name}
        value={value}
        disabled={disabled}
        className={cn([
          'p-2 peer-checked:bg-transparent peer-hover:bg-transparent peer-checked:hover:bg-transparent',
          className,
        ])}
      >
        {(isChecked) => (
          <>
            <div className='flex justify-start gap-4'>
              <div
                className={cn(
                  'ignore-font-scale flex aspect-square h-6 grow items-center justify-center rounded-full border-2 border-gray-400 text-center',
                  isChecked && 'border-primary text-primary',
                  disabled && 'border-gray-300 text-gray-300',
                )}
              >
                {isChecked ? <div className='bg-primary size-3 rounded-full' /> : null}
              </div>
              {label ? <div className={cn(disabled && 'text-gray-300')}>{label}</div> : null}
            </div>
          </>
        )}
      </Form.Radio>
      {endAdornment}
    </div>
  );
}

export default RadioButton;
